import React, { createContext } from 'react';
export var HasPortalParentContext = createContext(false);
export var HasPortalParentProvider = function (_a) {
    var children = _a.children;
    return (React.createElement(HasPortalParentContext.Provider, { value: true }, children));
};
